import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import NavbarComp from '../../shared/components/Navbar';
import { useAuth } from '../auth/hooks/useAuth';
import { useProducts } from '../products/hooks/useProducts';
import { useFavorite } from '../products/hooks/useFavorite';
import { useCarts } from '../products/hooks/useCart';
import Footer from '../../shared/components/Footer';
import Topbar from '../../shared/components/Topbar';
import { useNavigate, useParams } from 'react-router-dom';
import { useType } from './hooks/useType';
import ProductTypeList from './components/ProductTypeList';

const TypePageSection = ({ tittle }) => {

    const { param } = useParams();

    const navigate = useNavigate();

    const { searchProductPost } = useProducts();
    const { addFavoriteProduct } = useFavorite();
    const { addProductCart } = useCarts();

    const { productsSearchType, loading, searchProductTypePost } = useType();
    const bbb = productsSearchType

    const { validate } = useAuth();

    const [user, setUser] = useState()

    const handleOnAddToCart = async (data) => {
        const rowDataAddCart = {
            qty: 1,
            product: data
        }
        await addProductCart(rowDataAddCart);
        navigate('/cart');
    }

    useEffect(() => {
        (async () => {
            const userData = await validate();
            setUser(userData);
            await searchProductTypePost(param)
        })();

    }, [validate, searchProductTypePost]);

    const handleSearchProduct = (value) => {
        searchProductPost(value)
    }

    return (
        <>
            <NavbarComp searchProduct={handleSearchProduct} />
            <Container style={{
                backgroundColor: 'white',// Make sure the path is correct
                backgroundPosition: 'top right', // Position the image at the top-right corner
                backgroundSize: 'auto', // Adjust the size of the background image
                height: 'auto', // Make the container take full height (optional)    
                overflowY: 'hidden',
                overflowX: 'hidden',
                paddingBottom: '5%',
                paddingTop: '2%'
            }}>

                <Row>
                    <Col xs={12} md={12}>
                        <ProductTypeList
                            products={bbb}
                            onAddToFavorites={addFavoriteProduct}
                            onAddToCart={handleOnAddToCart}
                            loading={loading} />
                    </Col>
                </Row>

                <Footer />

            </Container>
        </>
    );

}

export default TypePageSection;
